import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';
import useAppEvent from 'hooks/useAppEvent';
import useNotify from 'hooks/useNotify';
import {
  AppEventType,
  PropertySettingsUpdatedEventPayload,
} from 'models/Events';
import { PropertySettingsPricingTabFormValues } from '../../PropertySettingsPricingTab.schema';
import { handlePropertyPriceSettingsUpdateSuccess } from './usePropertyPriceSettingsFormSubmit';

const PriceSettingsEventListeners = () => {
  const { subscribe, unsubscribe } = useAppEvent();
  const { reset } = useFormContext<PropertySettingsPricingTabFormValues>();
  const { notifySuccess } = useNotify();
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  useEffect(() => {
    const settingsUpdatedListener = async ({
      detail: { propertyUid },
    }: CustomEvent<PropertySettingsUpdatedEventPayload>) => {
      await handlePropertyPriceSettingsUpdateSuccess({
        notifySuccess,
        propertyUid,
        queryClient,
        reset,
        t,
      });
    };

    // @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    subscribe(AppEventType.PROPERTY_SETTINGS_UPDATED, settingsUpdatedListener);

    return () => {
      unsubscribe(
        AppEventType.PROPERTY_SETTINGS_UPDATED,
        // @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
        settingsUpdatedListener,
      );
    };
  }, []);

  return null;
};

export default PriceSettingsEventListeners;
